'use client';

import { useTranslations } from 'next-intl';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { alpha, useTheme } from '@mui/material/styles';

const steps = [
  { key: 'step1', number: '1' },
  { key: 'step2', number: '2' },
  { key: 'step3', number: '3' },
] as const;

export function HowItWorksSection() {
  const t = useTranslations('creator.personalBrandBot.howItWorks');
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
        bgcolor: 'grey.50',
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h4"
          component="h2"
          fontWeight={700}
          textAlign="center"
          sx={{ mb: { xs: 4, md: 5 } }}
        >
          {t('title')}
        </Typography>
        <Grid container spacing={4}>
          {steps.map(({ key, number }) => (
            <Grid key={key} size={{ xs: 12, md: 4 }}>
              <Box sx={{ textAlign: 'center' }}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                    color: 'primary.main',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mx: 'auto',
                    mb: 2,
                    fontWeight: 700,
                    fontSize: '1.25rem',
                  }}
                >
                  {number}
                </Box>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  {t(`${key}.title`)}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {t(`${key}.description`)}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
